export default __webpack_public_path__ + "static/media/mimo2.b93c212f.png";